import { BaseViewStore, HyperlinkCellData, HyperLinkTrackingNumberCellData } from 'core/stores';
import { observable, action, makeObservable } from 'mobx';
import { FulfillmentOrderStore } from 'modules/order/stores';
import { isSome } from 'core/utils';
import _ from 'lodash';

class FulfillmentOrdersExpandListViewStore extends BaseViewStore {
	@observable change = false;
	data = [];
	showActions = false;
	noDataItem = true;

	constructor(rootStore, componentProps) {
		super(rootStore);
		makeObservable(this);
		this.tableData = {
			columns: [
				{
					key: 'fulfillmentOrderId',
					title: 'MARKETPLACEORDERS.VIEW.FULFILLMENTORDER.VIEW.FULFILLMENTORDERID',
					dataCell: HyperlinkCellData,
					onClick: dataItem => this.openFulfillmentOrderDetailPage(dataItem.id),
					selected: true,
					width: 200,
					filter: null,
					resizable: false,
					sortable: false,
				},
				{
					key: 'sku',
					title: 'MARKETPLACEORDERS.VIEW.FULFILLMENTORDER.VIEW.PRODUCTSKU',
					selected: true,
					width: 200,
					filter: null,
					resizable: false,
					sortable: false,
				},
				{
					key: 'carrierService',
					title: 'MARKETPLACEORDERS.VIEW.FULFILLMENTORDER.VIEW.ASSIGNEDCARRIERSERVICE',
					selected: true,
					width: 200,
					filter: null,
					resizable: false,
					sortable: false,
				},
				{
					key: 'warehouseOrganization',
					title: 'MARKETPLACEORDERS.VIEW.FULFILLMENTORDER.VIEW.ASSIGNEDWAREHOUSE',
					selected: true,
					width: 200,
					filter: null,
					resizable: false,
					sortable: false,
				},
				{
					key: 'trackingNumber',
					title: 'MARKETPLACEORDERS.VIEW.FULFILLMENTORDER.VIEW.TRACKINGNUMBER',
					carrierServicePath: 'carrierService',
					dataCell: HyperLinkTrackingNumberCellData,
					selected: true,
					width: 200,
					filter: null,
					resizable: false,
					sortable: false,
				},
			],
			routes: {
				detail: id =>
					this.rootStore.routerStore.goTo('master.app.main.order.list.detail', {
						id,
					}),
			},
		};
		this.store = new FulfillmentOrderStore(rootStore);
		this.findFulfillmentOrder(componentProps.dataItem.id);
	}

	@action.bound
	setAsChanged = () => {
		this.change = !this.change;
	};

	@action.bound
	findFulfillmentOrder = async id => {
		this.suspend();

		this.data = _.map(
			(await this.store.findFulfillmentOrder({
				rpp: 100,
				page: 1,
				embed: [
					'fulfillmentOrderItems',
					'carrierService',
					'warehouseOrganization',
					'shipmentInfos',
					'shipmentInfos.shipmentInfoStatus',
				],
				orderId: id,
				fetchActiveShipments: true,
			})).item.slice(),

			dataItem => {
				return {
					id: dataItem.id,
					fulfillmentOrderId: dataItem.fulfillmentOrderId,
					sku: dataItem.fulfillmentOrderItems.length > 1 ? 'Multiple' : dataItem.fulfillmentOrderItems[0].sku,
					carrierService: dataItem.carrierService != null ? dataItem.carrierService.name : '',
					trackingNumber:
						isSome(dataItem.shipmentInfos) && dataItem.shipmentInfos.length > 0
							? dataItem.shipmentInfos.length > 1
								? 'Multiple'
								: dataItem.shipmentInfos[0].trackingNumber
							: '',
					warehouseOrganization: dataItem.warehouseOrganization ? dataItem.warehouseOrganization.applicationTitle : '',
					deliveryReplacement: dataItem.deliveryReplacement,
					shipmentInfoStatus:
						isSome(dataItem.shipmentInfos) &&
						_.some(dataItem.shipmentInfos, item => {
							return item.shipmentInfoStatus.abrv == 'active';
						})
							? 'active'
							: '',
				};
			}
		);

		this.setAsChanged();
		this.resume();
	};

	openFulfillmentOrderDetailPage = id => {
		this.rootStore.routerStore.goTo('master.app.main.order.list.detail', {
			id: id,
		});
	};
}

export default FulfillmentOrdersExpandListViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/FulfillmentOrdersExpandListViewStore.js